import React from "react"
import { useFooter } from "../../queries/useFooter"
import { RichText } from "prismic-reactjs"
import Logo from "../../images/logo-white.png"

import "./Footer.scss"

const Footer = () => {
  const footer = useFooter()

  return <div className='footer' id="impressum">
    <div className='box'>
        <img src={Logo} alt={footer.image.alt}/>
    </div>
    <div className='box'>
      <span className='label'>{footer.channel.label}</span>
      <div className='footer-icons'>
        <a href={footer.channel.facebook} className="fab fa-facebook"/>
        <a href={footer.channel.medium} className="fab fa-medium"/>
        <a href={footer.channel.youtube} className="fab fa-youtube"/>
        <a href={footer.channel.instagram} className="fab fa-instagram"/>
      </div>
    </div>
    <div className='box'>
      <span className='label'>{footer.contact.label}</span>
      <a className='email' href={"mailto:" + footer.contact.email}>{footer.contact.email}</a>
    </div>
    <div className='box'>
      <span className='label'>{footer.address.label}</span>
      <div>
        {RichText.render(footer.address.text)}
      </div>
    </div>
  </div>
}

export default Footer
